import ChartComponent from './ChartComponent';

export default ChartComponent;
